import { apiService } from "./apiService";
import { IEmailConfiguration, IEmailsLogsRequest, IEmailsServiceResponse } from "../types/emailsConfiguration";

export const EmailsConfigurationService = {
  getAll: (): Promise<IEmailsServiceResponse> => {
    return apiService.get('/api/emails-configuration').then(response => {
      const { data } = response;
      return data as IEmailsServiceResponse;
    });
  },
  update: (emailConfiguration: IEmailConfiguration) => {
    return apiService.put('/api/emails-configuration', { emailConfiguration });
  },
  getLogs: (request: IEmailsLogsRequest): Promise<IEmailsServiceResponse> => {
    return apiService.post('/api/emails-configuration/logs', { request }).then(response => {
      const { data } = response;
      return data as IEmailsServiceResponse;
    });
  }
}



// WEBPACK FOOTER //
// ./src/share/services/emails-configuration.ts